import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategorySection from './components/CategorySection';
import LatestArticlesSection from './components/LatestArticlesSection';
import FAQSection from './components/FAQSection';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';
import { faqItems } from '@/mocks/faq';

export default function Home() {
  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黑料入口 - 首页',
    description: '黑料入口首页为你提供吃瓜黑料入口、黑料入口最新地址直达服务，覆盖黑料吃瓜在线观看、最新网红塌房现场及热门黑料视频。',
    url: 'https://www.heiliaorukou.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料入口',
      url: 'https://www.heiliaorukou.com',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <SEOHead
        title="黑料入口 - 吃瓜黑料入口与黑料入口最新地址 | 每日黑料吃瓜在线"
        description="黑料入口首页为你提供吃瓜黑料入口、黑料入口最新地址直达服务，覆盖黑料吃瓜在线观看、最新网红塌房现场及热门黑料视频，是寻找可靠黑料访问路径的日常承接页。"
        keywords="黑料入口,吃瓜黑料入口,黑料入口最新地址,黑料吃瓜在线,黑料官网,黑料网入口,黑料在线观看,黑料吃瓜网站,免费黑料入口,51黑料入口,黑料入口网站,黑料网官网"
        canonicalUrl="https://www.heiliaorukou.com/"
        jsonLd={[homeJsonLd, faqJsonLd]}
      />

      <div className="min-h-screen">
        <Navbar />
        <main>
          <HeroSection />
          <TrendingSection />
          <CategorySection />
          <LatestArticlesSection />
          <StatsSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}